/**
 * Get typography values for a specific breakpoint
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import { getResponsiveValues } from '../../../common';
import type {
	ResponsiveBreakpoint,
	TypographyAttributes,
	TypographyValues,
} from '../../types';

/**
 * Get typography values for a specific breakpoint
 */
export const getTypographyValues = (
	attributes: TypographyAttributes,
	breakpoint: ResponsiveBreakpoint,
): TypographyValues => {
	return getResponsiveValues<TypographyValues>( attributes, breakpoint );
};
